// export const environment = {
//   production: false,
//   url: "https://ud-api.fof-fuso.com/eolmonitoringapi",
//   appMonitoringurl: "https://ud-api.fof-fuso.com/appmonitoringiam",
//   refresh_token_url:"https://ud-api.fof-fuso.com/tokenrefresh/redirect/eolmonitoring",
//   eol_url:"https://ud-api.fof-fuso.com/eoliam",
//   loginUrl_SSO:"https://d-redirect.fof-fuso.com/eolmonitoringapp",
//   logoutUrl_SSO:"https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1/oauth2/v2.0/logout",
//   saas_token: '?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-09-02T19:37:57Z&st=2023-09-01T11:37:57Z&spr=https&sig=8bfUkvXYKqpQSJB81IdhfvLXG5ufKBqQzP6F%2B6RXjac%3D'

// };
export const environment = {
  production: false,
  appMonitoringurl:'',
  url: "https://uapi.fof-fuso.com/eolmonitoringiam",
  refresh_token_url:"https://ud-api.fof-fuso.com/tokenrefresh/redirect/eolmonitoring",
  loginUrl_SSO:"https://redirect.fof-fuso.com/eolmonitoringapp",
  eol_url:"https://uapi.fof-fuso.com/eoliam",
 // loginUrl_SSO:"https://udfl-idm.fof-fuso.com/auth/realms/dfl/protocol/openid-connect/auth?client_id=f2b814fc&redirect_uri=https://uredirect.fof-fuso.com/callback/eolMonitoring&scope=openid&response_type=code%20token&response_mode=form_post&nonce=x52vxebmxs",
 logoutUrl_SSO:"https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1/oauth2/v2.0/logout",
  saas_token: "?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2036-11-30T06:54:14Z&st=2026-09-13T22:39:14Z&spr=https&sig=HpK5R4lwIZAulEu%2B1R%2Fgp%2Bb6NcflOhV1WxFUxD2K4lU%3D"
};
